
import React, { useEffect, useRef, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight, MdCreate, MdBlock, MdAdd, MdOutlineCircle } from "react-icons/md";
import { useNavigate } from 'react-router-dom'; 
import _constantUtil from '../../../utils/Constant' 
import { Tooltip } from 'react-tooltip'; 

function GlobalQuestion() { 
    const navigate = useNavigate(); 
    const [showConfirmation, setShowConfirmation] = useState(_constantUtil.BOOLEAN_FALSE); 
    const rowsPerPage = 20;

    const confirmationRef = useRef(_constantUtil.NULL);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (confirmationRef.current && !confirmationRef.current.contains(event.target)) {
                setShowConfirmation(_constantUtil.BOOLEAN_FALSE); 
            }
        };
  
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };    
    }, []);

    const handlePageChange = ({ selected }) => {
        const start = selected * rowsPerPage;
        const end = start + rowsPerPage;  
    };
    
  return (
    <> 
    {showConfirmation && (
        <div>
            <div className='confirmation-overlay'></div>
            <div ref={confirmationRef} className='confirmation-dialog'>
                <p>Are you sure to update question status?</p>
                <div className='d-flex justify-content-end'>
                    <button onClick={() => setShowConfirmation(_constantUtil.BOOLEAN_FALSE)} className='border-0 rounded px-3 bg-danger text-white p-2'>Cancel</button>
                    <button   className='border-0 rounded px-3 bg-success text-white p-2'  > Confirm </button>
                </div>
            </div>
        </div>
    )}
    <div className='px-4 mt-4'>
        <div className='container-fluid p-0'>
            <div className='row'>
                <h4 className='header-title pb-3 text-muted'>Global Question</h4>
                <div className='col-12'>
                    <div className='card'>
                        <div className='card-body'>

                            <div className='d-flex justify-content-end align-items-center mb-2'>
                                <div className=''>
                                    <button
                                        type='button'
                                        onClick={() => navigate('/question/add-question')}
                                        className='btn text-white d-flex align-items-center'>
                                        <MdAdd className='fs-5 me-1 ' />
                                        Add
                                    </button>
                                </div>
                            </div>

                            <div className='table-responsive'>
                                <table id='scroll-horizontal-datatable' className='table w-100 nowrap'>
                                    <thead>
                                        <tr>
                                            <th>SN</th>
                                            <th>Category</th>
                                            <th>Question</th>
                                            <th className="text-nowrap">Option One</th>
                                            <th className="text-nowrap">Option Two</th>
                                            <th>Result</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody> 

                                            <tr >
                                                <th scope='row'>1</th>
                                                <td>
                                                    <span className='badge badge-info-lighten'>
                                                        1x2
                                                    </span>
                                                </td>
                                                <td  className="text-nowrap">Who will the match ?</td> 
                                                <td>Team a</td>
                                                <td>Team b</td>
                                                <td>
                                                    <span className='badge badge-warning-lighten'>
                                                       instant
                                                    </span>
                                                </td>
                                                <td> 
                                                    <span className='badge badge-success-lighten'>
                                                        ACTIVE
                                                    </span> 
                                                </td>
                                                <td>
                                                    <div className='d-flex align-items-center justify-content-center'>
                                                        <MdCreate data-tooltip-id='globalbets' data-tooltip-content="Update Question"
                                                            className=' jumbo-icon  me-2 fs-5' style={{cursor: 'pointer', color:'gray'}}
                                                            onClick={() => navigate('/question/update-question')}
                                                        />
                                                        <Tooltip border={false} id='globalbets' place="bottom" effect="solid" />
 
                                                        <>
                                                            <MdBlock data-tooltip-id='activeglobalbets' data-tooltip-content="Inactive Question"
                                                                className='jumbo-icon me-2 pointer user-status fs-5' style={{ cursor: 'pointer', color: 'red' }} 
                                                                onClick={()=>setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                            />
                                                            <Tooltip border={false} id='activeglobalbets' place="bottom" effect="solid" />
                                                        </> 
                                                        <>
                                                            <MdOutlineCircle
                                                                data-tooltip-id='inactivebetsglobal' data-tooltip-content="Active Question"
                                                                className='jumbo-icon pointer user-status fs-5 me-2' style={{ cursor: 'pointer', color: 'green' }} 
                                                                onClick={()=>setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                            />
                                                            <Tooltip id='inactivebetsglobal' place="bottom" effect="solid" />
                                                        </> 
                                                    </div>
                                                </td>
                                            </tr> 
                                         
                                            <tr >
                                                <th scope='row'>2</th>
                                                <td>
                                                    <span className='badge badge-info-lighten'>
                                                    1x2
                                                    </span>
                                                </td>
                                                <td  className="text-nowrap">Both team score ?</td> 
                                                <td>no</td>
                                                <td>yes</td>
                                                <td>
                                                    <span className='badge badge-warning-lighten'>
                                                    after match
                                                    </span>
                                                </td>
                                                <td> 
                                                    <span className='badge badge-success-lighten'>
                                                        ACTIVE
                                                    </span> 
                                                </td>
                                                <td>
                                                    <div className='d-flex align-items-center justify-content-center'>
                                                        <MdCreate data-tooltip-id='globalbets' data-tooltip-content="Update Question"
                                                            className=' jumbo-icon  me-2 fs-5' style={{cursor: 'pointer', color:'gray'}}
                                                            onClick={() => navigate('/question/update-question')}
                                                        />
                                                        <Tooltip border={false} id='globalbets' place="bottom" effect="solid" />
 
                                                        <>
                                                            <MdBlock data-tooltip-id='activeglobalbets' data-tooltip-content="Inactive Question"
                                                                className='jumbo-icon me-2 pointer user-status fs-5' style={{ cursor: 'pointer', color: 'red' }} 
                                                                onClick={()=>setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                            />
                                                            <Tooltip border={false} id='activeglobalbets' place="bottom" effect="solid" />
                                                        </> 
                                                        <>
                                                            <MdOutlineCircle
                                                                data-tooltip-id='inactivebetsglobal' data-tooltip-content="Active Question"
                                                                className='jumbo-icon pointer user-status fs-5 me-2' style={{ cursor: 'pointer', color: 'green' }} 
                                                                onClick={()=>setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                            />
                                                            <Tooltip id='inactivebetsglobal' place="bottom" effect="solid" />
                                                        </> 
                                                    </div>
                                                </td>
                                            </tr> 
                                         
                                            <tr >
                                                <th scope='row'>3</th>
                                                <td>
                                                    <span className='badge badge-info-lighten'>
                                                    Goal Score
                                                    </span>
                                                </td>
                                                <td  className="text-nowrap">both team score in 1st ha...</td> 
                                                <td>even</td>
                                                <td>odd</td>
                                                <td>
                                                    <span className='badge badge-warning-lighten'>
                                                    manual
                                                    </span>
                                                </td>
                                                <td> 
                                                    <span className='badge badge-success-lighten'>
                                                        ACTIVE
                                                    </span> 
                                                </td>
                                                <td>
                                                    <div className='d-flex align-items-center justify-content-center'>
                                                        <MdCreate data-tooltip-id='globalbets' data-tooltip-content="Update Question"
                                                            className=' jumbo-icon  me-2 fs-5' style={{cursor: 'pointer', color:'gray'}}
                                                            onClick={() => navigate('/question/update-question')}
                                                        />
                                                        <Tooltip border={false} id='globalbets' place="bottom" effect="solid" />
 
                                                            <>
                                                                <MdBlock data-tooltip-id='activeglobalbets' data-tooltip-content="Inactive Question"
                                                                    className='jumbo-icon me-2 pointer user-status fs-5' style={{ cursor: 'pointer', color: 'red' }} 
                                                                    onClick={()=>setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                                />
                                                                <Tooltip border={false} id='activeglobalbets' place="bottom" effect="solid" />
                                                            </> 
                                                            <>
                                                                <MdOutlineCircle
                                                                    data-tooltip-id='inactivebetsglobal' data-tooltip-content="Active Question"
                                                                    className='jumbo-icon pointer user-status fs-5 me-2' style={{ cursor: 'pointer', color: 'green' }} 
                                                                    onClick={()=>setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                                />
                                                                <Tooltip id='inactivebetsglobal' place="bottom" effect="solid" />
                                                            </> 
                                                    </div>
                                                </td>
                                            </tr> 

                                    </tbody>
                                </table>
                            </div>
                            <ReactPaginate
                                previousLabel={<MdKeyboardArrowLeft className='fs-4' />}
                                nextLabel={<MdKeyboardArrowRight className='fs-4' />}
                                className='pagination'
                                breakLabel={'...'}
                                breakClassName={'break-me'}  
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageChange}
                                containerClassName={'pagination'}
                                subContainerClassName={'pages pagination'}
                                activeClassName={'pagination-active-page'}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</>
  )
}

export default GlobalQuestion
